const prefix = "media";

export const mediaRoutes = {
  create: `${prefix}`,
  list: `${prefix}`,
  update: (id: number) => `${prefix}/${id}`,
  get: (id: number) => `${prefix}/${id}`,
  delete: (id: number) => `${prefix}/${id}`,
  notifyUploaded: (id: number) => `${prefix}/${id}/uploaded`,
};

